<mat-form-field [appearance]="appearance" [ngClass]="isTodayDisabled ? 'todayDisable':'todayAvailable'">
  <input
    #dateInput
    matInput
    [matDatepicker]="picker"
    [(ngModel)]="value"
    [max]="maxDate"
    [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
    [min]="minDate"
    (focus)="picker.open()"
    (dateChange)="change()"
    [placeholder]="value ? value : placeholder"
    [disabled]="disabled || readOnly"
    [matDatepickerFilter]="dateFilter"
    [class]="isTodayDisabled ? 'todayDisable':'todayAvailable'"
    
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker (closed)="dateInput.blur()"></mat-datepicker>
</mat-form-field>
<!-- <h2>
  {{ disabledDates | json }}
</h2> -->
